module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-face-smiley-think-svgrepo-com.c9b1523a.svg";